import { Controller } from "@hotwired/stimulus"
import { pluralText } from "../../utils/plural-category.util"

// Connects to data-controller="documents--items-counter"
export default class extends Controller {
  static targets = ["count", "suffix"]

  static values = {
    lang: String,
    texts: { type: Object, default: {} }
  }

  connect() {
    this.updateCount()
    this.#observeItems()
  }

  disconnect() {
    if (this.#observer) {
      this.#observer.disconnect()
    }
  }

  #observer = null

  #observeItems() {
    const container = this.#findContainer()
    if (!container) return

    // Watch for changes to the items container (additions/removals)
    this.#observer = new MutationObserver(() => {
      this.updateCount()
    })

    this.#observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"]
    })
  }

  updateCount() {
    const container = this.#findContainer()
    if (!container) return

    const items = Array.from(container.querySelectorAll("tr.invoice-item"))
      .filter((row) => !row.classList.contains("d-none"))
      .filter((row) => !this.#isDestroyed(row))

    const count = items.length
    if (this.hasCountTarget) {
      this.countTarget.textContent = String(count)
    }

    if (this.hasSuffixTarget) {
      this.suffixTarget.textContent = this.#pluralize(count)
    }
  }

  #pluralize(count) {
    return pluralText(this.textsValue, this.langValue, count)
  }

  #findContainer() {
    return (
      this.element.querySelector('tbody[id$="_items_tr"]') ||
      document.querySelector("#expense_items_tr") ||
      document.querySelector("#document_items_tr") ||
      null
    )
  }

  #isDestroyed(row) {
    const destroyInput = row.querySelector('input[type="hidden"][name*="_destroy"]')
    return destroyInput && destroyInput.value === "true"
  }
}
